<template>
  <div class="shop-evaluate-list">
    <mt-loadmore
        v-if="evaluateList.length > 0"
        style="font-size:0.24rem;color: #aaaaaa;position: relative"
        :bottom-method="loadBottom"
        :bottom-all-loaded="allLoaded"
        :auto-fill ='false'
        bottomLoadingText = '加载更多'
        ref="loadmore">
      <div v-for="evaluate in evaluateList" class="shop-evaluate-item general-box-shadow">
        <img class="author" src="../../assets/icon/icon-defualt-avatar.png"/>
        <div class="evaluate-info">
          <div class="name">{{evaluate.phone}}</div>
          <div class="date">{{evaluate.createTime | simpleDayFilter}}</div>
          <div class="econtent">{{evaluate.content}}</div>
          <div class='evaluate-additional' v-if="!!evaluate.additionalComments">
            <div class="info">用户{{(evaluate.additionalComments.createTime - evaluate.createTime) | formatterDays }}天后追评</div>
            <div class='econtent'>{{evaluate.additionalComments.content}}</div>
            <div class="piclist" v-if="evaluate.additionalComments.attachmentList.length > 0">
              <template v-for="(attachment,idx) in evaluate.additionalComments.attachmentList">
                <img class="pic" mode="aspectFill" :src="attachment.url" v-if="idx < 3"/>
              </template>
            </div>
          </div>
        </div>
        <div class="evaluate-score" v-if="evaluate.score === '1'">
          <img src='../../assets/evaluate_score_bg.png' class='evaluate-score-bgimg'/>
          <div class='score-info'>
            <div class='score'>5.0</div>
            <div class='unit'>评分</div>
          </div>
        </div>
      </div>
    </mt-loadmore>
    <div class="emptylist" v-if="evaluateList.length === 0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">该店铺还未收到评价!</div>
    </div>
  </div>
</template>

<script>
  import tradeEvaluateService from '../../service/trade/TradeEvaluateService'

  export default {
    name: 'EvaluateList',
    props:{
      shopId:String,
    },
    data () {
      return {
        pageNo: 1,
        evaluateList:[],
        allLoaded: false,
      }
    },
    beforeMount () {
      this.init()
    },
    methods: {
      init(){
        this.evaluateList = []
        this.pageNo = 1
        this.loadEvaluateList();
      },
      loadBottom(){
        this.pageNo++
        this.loadEvaluateList()
      },
      async loadEvaluateList(){
        let {code,msg,data} = await tradeEvaluateService.list(this.shopId,this.pageNo);
        if(code == '0'){
          this.allLoaded = data.evaluateList.length === 0;
          for (let evaluate of data.evaluateList){
            evaluate.phone = evaluate.phone.substring(0,3)+"****"+evaluate.phone.substring(7,11);
          }
          this.evaluateList.push(...data.evaluateList);
        }
      },
    }
  }
</script>
<style lang="scss" scoped>
  .shop-evaluate-list{
    width: 6.9rem;
    margin: 0 auto;
    .shop-evaluate-item{
      position: relative;
      display: flex;
      margin-bottom: 0.2rem;
      .author{
        width: 0.88rem;
        height: 0.88rem;
        flex-grow: 0;
        flex-shrink: 0;
        border-radius: 0.88rem;
        margin: 0.2rem;
      }
      .evaluate-info{
        margin-top: 0.3rem;
        margin-bottom: 0.3rem;
        padding-right: .2rem;
        width: 1rem;
        flex-grow: 1;
        flex-shrink: 1;
        font-size: 0.28rem;
        color: #191818;
        .date{
          margin-bottom: 0.09rem;
          font-size: 0.24rem;
          color: #7f7d7c;
        }
        .econtent{
          font-size: 0.32rem;
        }
        .evaluate-additional{
          margin-top: .10rem;
          font-size: .32rem;
          color: #191818;
          .info{
            font-size: .28rem;
            color: #D54A33;
          }
          .econtent{
            margin-top: .05rem;
          }
          .piclist{
            display: flex;
            flex-flow: row nowrap;
            justify-content: space-between;
            align-items: center;
            margin-top: .1rem;
            .pic{
              width: 1.60rem;
              height: 1.60rem;
              border-radius: .10rem;
              margin:0;
            }
          }
        }
      }
      .evaluate-score{
        width: .58rem;
        height: .78rem;
        position: absolute;
        right: .22rem;
        top: 0px;
        .evaluate-score-bgimg{
          width: 100%;
          height: 100%;
          border-radius: 0px;
          margin: 0;
          display: block;
          position: absolute;
          z-index: 1;

        }
        .score-info{
          position: relative;
          z-index: 2;
          display: flex;
          flex-flow: column nowrap;
          justify-content: center;
          align-items: center;
          padding-top: .10rem;
          .score{
            line-height: 1em;
            font-size: .22rem;
            font-weight: bold;
            color: #fff;
          }
          .unit{
            line-height: 1em;
            font-size: .18rem;
            margin-top: .03rem;
            color: #fff;
          }
        }
      }
    }
    .emptylist{
      height: 100vh;
      text-align: center;
      img{
        width: 1.57rem;
        height: 1.57rem;
        margin-top: 2.32rem;
      }
      .tip{
        margin-top: 0.4rem;
        font-size: 0.32rem;
        color: #7f7d7c;
      }
    }
  }
</style>
